<template>
    <div>
        <app-data-table
            :fields="fields"
            :items="tableData"
            :current-page="data.current_page"
            :last-page="data.last_page"
            :from="data.from"
            :to="data.to"
            :total="data.total"
            :per-page="data.per_page"
            :on-change-page="onChangePage"
            @sort="sort"
        >
            <template slot="profile.name" slot-scope="data">
                <span>{{ data.item.profile ? data.item.profile.name : '' }}</span>
                <small
                    v-if="data.item.profile && data.item.profile.slug === 'contractor'"
                    class="d-block text-muted"
                >
                    Documentación configurable al editar
                </small>
            </template>
            <template slot="actions" slot-scope="data">
                <b-button size="sm" variant="primary" class="mr-1" @click="editUser(data.item)"><i class="fa fa-edit"></i></b-button>
                <b-button size="sm" variant="danger" @click="removeUser(data.item)"><i class="fa fa-trash"></i></b-button>
            </template>
        </app-data-table>
    </div>
</template>
<script>
import fields from './fields';
export default {
    props: {
        data: {
            type: Object
        }
    },
    data(){
        return {
            fields: fields,
        }
    },
    computed: {
        tableData(){
            if(!this.data || !this.data.data) return [];
            return this.data.data;
        }
    },
    methods: {
        sort(sortConf) {
            this.$emit('sort', sortConf);
        },
        onChangePage(page){
            this.$emit('change-page', page);
        },
        removeUser(data) {
            this.$emit('remove-user', data);
        },
        editUser(data) {
            this.$emit('edit-user', data);
        }
    }
}
</script>
